var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"oldFrame",staticStyle:{"height":"calc(100vh - 126px)","width":"100%"},attrs:{"frameborder":"0","src":_vm.frameUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }